import { Component, ComponentFactoryResolver, ComponentRef, Inject, Injector, OnInit, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { dateSuffixes, homeRoute, monthNamesArr } from '@app-constants/app.constants';
import { tempstates } from '@app-constants/offline-centers';
import { attemptTestNow, availableForAttempt } from '@app-modules/feature/dashboard/component/info-box/info-box.component';
import { AuthService } from '@app-services/auth-service/auth.service';
import { BoardsService } from '@app-services/boarrds/boards.service';
import { ScheduleService } from '@app-services/schedule/schedule.service';
import { ExamService } from '@app-services/test/exam.service';
import { TestlistService } from '@app-services/test/testlist.service';
import { UserService } from '@app-services/user/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { getILCookie, setILCookie, setLoggedInUserData, getCourseId } from 'src/app/helpers/functions';
import * as html2pdf from 'html2pdf.js';
import { ScoreCertificateComponent as scorecertificatecomponent } from '../score-certificate/score-certificate.component';
import * as moment from 'moment';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import {centersData} from '@app-constants/score-new-centers';
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import { pincodelist } from '@app-constants/pincode-list';
import { offlineCitys } from '@app-constants/scoreCity/offline-city';
import { Offline_Online } from '@app-constants/scoreCity/offline-onlinecitys';
import { tr } from 'date-fns/locale';
import { toiCitys } from '@app-constants/scoreCity/toi-city-list';
import { scUniqueCitys } from '@app-constants/scoreCity/sc_unique_citys';
import { toiOfflineOnlineCitys } from '@app-constants/scoreCity/toi-offline-online-citys';
import { newCentersData } from '@app-constants/scoreNewData/newscorecenterslist';
import { newscorepincodelist } from '@app-constants/scoreNewData/newscorepincodelist';
import { ScoreReportComponent } from '../score-report/score-report.component';
const testSpanFormat = /\s*([0-9]{4})-([0-9]{2})-([0-9]{2})\s*([0-9]{1,2}:[0-9]{2}\s*(am|pm))\s*/i;
@Component({
  selector: 'app-score-actions',
  templateUrl: './score-actions.component.html',
  styleUrls: ['./score-actions.component.css']
})
export class ScoreActionsComponent implements OnInit {
  actions: any = {
    attempt: {
      desc: 'Attempt Test',
      clickText: 'Attempt Now'
    },
    reschedule: {
      desc: 'Reschedule Test Form',
      clickText: 'Reschedule Test'
    },
    download: {
      desc: 'Download Hall Ticket',
      clickText: 'Download Hall Ticket'
    }, participation:{
      desc: 'Download Test Report and Certificate',
      clickText: 'Download Certificate'
    },
    // scorereport:{
    //   desc: 'Download Test Report',
    //   clickText: 'Download Test Report'
    // }
  };
  tempExamStates = centersData;
  newCentersData = newCentersData;
  filteredCities:any = [];
  filteredCenters:any = []
  filteredStates:any =[];
  rescheduleForm!: FormGroup;
  action: string = '';
  actionDesc: string = '';
  actionClickText: string = '';
  noTestMsg: string = 'Sorry you have not registered for any test';
  userData: any;
  dataFetched: boolean = false;
  tests: any = [];
  step: Number = 2;
  grades: any;
  gradesFetched: boolean = false;
  attemptTestNow = attemptTestNow;
  dateDayarr: any= [];
  hallTicketInfo:any = {
    hallticketNo: '',
    state:'',
    city:'',
    center:'',
    date:'',
    timeslot:'',
    examEndTime:'',
    centerAddress:'',
    exam:'',
    grade:''
  }
  totalSlots:any =[]
  selectedGradeName: any;
  selectedIndex: any;
  examAttemptedDifferentGrade:any =[]
  rescheduleSubscriptionPackage:any ={}
  selectedTestData:any;
  datedata:any;
  isOffline:boolean = false;
  isOnline:boolean = false;
  selectedPincode:any;
  pincodeList = newscorepincodelist;
  pincodefilteredDistrict:any = [];
  pincodefilteredCities:any = [];
  pincodefilteredStates:any = [];
  OfflineCitys = offlineCitys;
  BothOffline_OnlineCity = Offline_Online;
  toi_citys = toiCitys;
  sc_uniqes_citys = scUniqueCitys;
  toiOfflineOnlineCitys = toiOfflineOnlineCitys;
  selectedTime:any;
  centerAddress:any;
  HallticketisOffline:boolean = false;
  isOnlinetoOffline: boolean = false;
  rescheduleOnlineOffline: boolean = false;
  rescheduleCoupon:any;
  isrescheduleCouponApplied:boolean = false;
  examsList:any;
  rescheduleTime:any;
  getExamDateInHours:any;
  tooltip = "This test can't be rescheduled. You can reschedule tests only 24 hours before the exam date and time.";
 @ViewChild('scorecomponent ',{read:ViewContainerRef}) public scorecomponent:ViewContainerRef;
 @ViewChild('scorecomponentreport ',{read:ViewContainerRef}) public scorecomponentreport:ViewContainerRef;
  constructor(private activatedRoute: ActivatedRoute, private router: Router, private userService: UserService, private authService: AuthService, private scheduleService: ScheduleService, private spinner: NgxSpinnerService, private testListService: TestlistService, private targetExamService: BoardsService, private formBuilder: FormBuilder, private examService: ExamService,public resolver :ComponentFactoryResolver,public injector :Injector, public webengage:GAnalyticsService, private subscriptionService: SubscriptionService) {
    const data = this.activatedRoute.snapshot.data || {};
    this.action = data.action;
    console.log(this.action);
    let cookieData = getILCookie('INFINITY_LEARN');
    let token = localStorage.getItem('token');
    if(cookieData){
      let data = JSON.parse(cookieData);
      setLoggedInUserData(data, this.userService, this.authService);
      this.webengage.webEngageEvent({
        'event': 'User Sign In' ,
        'phone': data?.userDto?.phone,
      })
      setILCookie('INFINITY_LEARN', '', -1);
    } else if(token)  {
      this.action = data.action;
    } else  {
      this.router.navigate(['/dashboard']);
      return;
    }
   }
   fetchGradesList() {
     this.spinner.show();
    this.targetExamService.fetchGradesList().subscribe((data: any) => {
      this.gradesFetched = true;
      if(this.selectedTestData?.source === 'score-toi'){
        this.grades = data.slice(0,12);
      } else {
        this.grades = data;
      }
      this.spinner.hide();
    });
  }
  getmysubscriptions(grade){
    const user = localStorage.getItem('user_details_from_server') ? JSON.parse( localStorage.getItem('user_details_from_server'))  :{};
   return this.scheduleService.mySubscription({userId:user?.userId,grade:grade}) 
  }
  ngOnInit(): void {
    this.testListService.getCurrentServerTime();
    this.userData =  localStorage.getItem('user_details_from_server') ? JSON.parse(localStorage.getItem('user_details_from_server')):{};
    this.actionDesc = this.actions[this.action]?.desc;
    this.actionClickText = this.actions[this.action]?.clickText;
    console.log(this.actionClickText);
    if(this.action == 'download') {
      this.noTestMsg = 'Sorry you have not registered for any offline test';
    }
    this.spinner.show();
    // this.scheduleService.getSCORERegistrations({phone: localStorage.getItem('studentid'),action:this.action }).subscribe(data => {
    //   this.dataFetched = true;
    //   if(Array.isArray(data)) {
    //     this.tests = data;
        
        if(this.action == 'download') {
          this.dataFetched = true;
          this.scheduleService.getStudentHalltickets().subscribe((resp:any)=>{
            console.log(resp);
            this.tests = resp;
            this.dateTimeSet();
            this.HallticketisOffline = true;
            this.spinner.hide();
          });
          // this.tests = this.tests.filter(te => te?.mode?.toLowerCase() == 'offline');
        } else if(this.action == 'attempt') {
          this.tests = this.tests.filter(te =>  !te?.isSubmitted);
          this.updateTestsStatus(this.tests);
        } else if(this.action == 'participation'){
          this.dataFetched = true;
          this.scheduleService.getStudentScheduledScoreExamsData().subscribe((resp:any)=>{
            console.log(resp);
            this.tests = resp;
            this.tests = this.tests.filter(te => te?.isSubmitted);
            this.dateTimeSet();
            this.tests.forEach(e=>{
              e.examSubmittedTime = moment(e?.examstartedon).add(e?.duration, 'm').toDate();;
            })
            // console.log(this.tests);
            // this.spinner.show();
            // this.testListService.ScoreScheduleListDetails().subscribe((attemptExamData)=>{
            //   attemptExamData = attemptExamData.filter(v=>(v.isExamSubmittedByUser));
            //   console.log(attemptExamData);
            //   resp.forEach(e=>{
            //   e.examStartTime = attemptExamData?.find(ele=>ele._id == e?.ruleid)?.examStartTime;
            //   });
            //   this.tests = resp;
            //   this.dateTimeSet();
            //   console.log(this.tests);
            //   this.spinner.hide();
            // });
            this.spinner.hide();
          });

        } else if(this.action == "reschedule"){
          this.dataFetched = true;
          this.scheduleService.getStudentScheduledExamsData().subscribe((resp:any)=>{
            console.log(resp);
            this.tests = resp.filter(ele=>ele.isActive == 'true' && ele.isScore);
            // this.tests.filter(te => te?.isoffline == true);
            let serverTime = localStorage.getItem('serverTime');
            let current_time = moment.unix(Number(serverTime)).format("YYYY-MM-DD HH:mm:ss");
            console.log(current_time);
            this.tests.forEach((v)=>{
              let today = new Date(current_time);
              let examData = new Date(v?.span);
              if(v?.span !=""){
                v.timediffrence = this.timeDiffCalc(examData,today);
                if(examData < today){
                  v.isPast = true;
                } else {
                  v.isPast = false;
                }
              }
            });
            console.log(this.tests);
            this.dateTimeSet();
            this.rescheduleOnlineOffline = true;
            this.spinner.hide();
              // this.pincodefilteredStates = []
            this.userService.getStates().subscribe((res:any)=>{
              this.pincodefilteredStates = res?.response;
              this.pincodefilteredStates.sort((a: any, b: any) =>{
                if(a.name < b.name) { return -1; }
                if(a.name > b.name) { return 1; }
                return 0;
              });
              console.log(this.pincodefilteredStates,'States');
            })
          });
          // this.tests = this.tests.filter(te => !te?.isSubmitted);
        }
    //   }
      
    //   this.spinner.hide();
    // }, () => {
    //   //this.spinner.hide();
    // });
  // this.pincodefilteredStates = []
  // this.pincodeList.forEach((val)=>{
  //   if(!this.pincodefilteredStates.includes(val.State)){
  //       this.pincodefilteredStates.push(val.State)
  //   }   
  // }); 
  this.spinner.hide();
  this.getExams();
  }

  dateTimeSet(){
    this.tests.forEach(te => {
      const execRes = testSpanFormat.exec(te.span);
      if(execRes) {
        const dt = Number(execRes[3]);
        const dateStr = dt + (dateSuffixes[dt]? dateSuffixes[dt]: "th" )+ " "+ monthNamesArr[Number(execRes[2]) - 1] + ", " + execRes[1];
        te.date = dateStr;
        te.time = execRes[4];
      }
    }); 
    console.log(this.tests);
  }
  timeInterval: any;
  updateTestsStatus(filterTestList:any) {
  
    // if (this.timeInterval) {
    //   clearInterval(this.timeInterval);
    // }
    //store upcoming test
     
  filterTestList.forEach((te:any) => {
    if(availableForAttempt(te)) {
      te.status = 'attempt';
    }
  })
  const testsToUpdate = filterTestList.filter(ft => ft.status != 'attempt');
  testsToUpdate.forEach((v)=>{
    let servertime =  moment.unix(+localStorage.getItem('serverTime'))
    let attemptime = moment(v.span).subtract(10, "minutes")
    let timedifference_ms= attemptime.diff(servertime,'milliseconds',true);
    this.timertowait(v,timedifference_ms)
  })
  this.tests = filterTestList;
    // this.timeInterval = setTimeout(() => {
    //   
      
    //   this.updateTestsStatus(this.tests);
    // }, 30000);
  }
  timertowait(test,timedifference_ms){
    setTimeout(() => {
      this.tests.forEach((v)=>{
        if(v._id == test._id){
          v.status = 'attempt';
        }
      })
    }, timedifference_ms);
  }
  goBack() {
    this.step = 2;
  }
  gotoHome() {
    window.location.href= homeRoute+'score';
  }
  get rshdForm() {
    return this.rescheduleForm.controls;
  }
  testToReschedule: any;
  handleAction(test) {
    console.log('Selected Test Data', test);
    if(this.action == 'reschedule') {
      let today = new Date();
      let createdDate = new Date(test?.createdDate);
      this.timeDiffCalc(createdDate,today)
      this.testToReschedule = test;
      this.step = 3;
      this.rescheduleForm = this.formBuilder.group({
        mode: ['', [Validators.minLength(1), Validators.required]],
        grade:['', [Validators.minLength(1), Validators.required]],
        exam: ['', [Validators.minLength(1), Validators.required]],
        date: ['', [Validators.minLength(1), Validators.required]],
        time: ['', [Validators.minLength(1), Validators.required]],
        span: ['', [Validators.minLength(1), Validators.required]],
        ruleid: ['', [Validators.minLength(1), Validators.required]],
        scheduleid: [''],
        state:[''],
        city:[''],
        district:[''],
        center:[''],
        duration: ['']
      });
      this.fetchGradesList();
      this.selectedTestData = test;
    } else if(this.action == 'attempt') {
      if(test.status == 'attempt') {
       localStorage.setItem('targetExamName',test?.coursetype )
       this.webengage.webEngageEvent({ 
        'event': 'CTA-Attempt Test Now',
        'page_url': homeRoute+this.router?.url,
      });
        
        this.attemptTestNow({...test, enrolled: true}, 'SCHOLARSHIPTEST');
      }
    } else if(this.action == 'download'){
      let centerAddress =  this.tempExamStates.find(ele=>ele.CENTER == test?.center && ele.CITY.toLocaleUpperCase() == test?.city?.toLocaleUpperCase());
      let centerAddress2 = this.newCentersData.find(ele=>ele.Center == test?.center && ele.City.toLocaleUpperCase() == test?.city?.toLocaleUpperCase());
      this.webengage.webEngageEvent({ 
        'event': 'CTA-Hall Ticket Downloaded',
        'page_url': homeRoute+this.router?.url,
      });
      this.hallTicketInfo.hallticketNo = test?.hallticket;
      this.hallTicketInfo.center = test?.center;
      this.hallTicketInfo.city = test?.city;
      this.hallTicketInfo.state = test?.state;
      this.hallTicketInfo.date = test?.span?.split(' ')[0];
      this.hallTicketInfo.timeslot = test?.span?.slice(11);
      this.hallTicketInfo.examEndTime =   moment(test?.span,"YYYY-MM-DD hh:mm A").add(+test?.duration, 'minutes').format('hh:mm A');
      this.hallTicketInfo.centerAddress = centerAddress?.CENTER_ADDRESS || centerAddress2?.CenterAddress || test?.centerAddress;
      this.hallTicketInfo.exam = test?.examname;
      this.hallTicketInfo.grade = test?.grade;
      let data1 = document.getElementById('hallTicket');
      
      html2pdf().from(data1).set({
        filename: `${ test?.examname}.pdf`,
        image: { type: 'jpeg', quality: 0.95 },
        margin: 0,
        pagebreak: {mode: 'legacy' },
        jsPDF: {orientation: 'portrait', unit: 'in', format: 'letter'}
      }).save();
    } else if (this.action == 'participation'){
      this.webengage.webEngageEvent({ 
        'event': 'CTA-SCORE Certificate Downloaded',
        'page_url': homeRoute+this.router?.url,
      });
      let componentFactory = this.resolver.resolveComponentFactory(scorecertificatecomponent)
      const {instance} = this.scorecomponent.createComponent (componentFactory, null, this.injector);
      instance.dateofexam = test?.isoffline ? '30-Jan-2023' : test?.examsubmittedon?.split(' ')?.[0];
    }
  }
  get rescheduleFormControls(){
    return this.rescheduleForm.controls
  }

  changeFormValue(fieldName, val) {
    const examField = this.rescheduleForm.get(fieldName);
    if(examField?.value != val) {  
      this.rescheduleForm.get(fieldName)?.setValue(val);
      if(this.rescheduleForm?.value.mode == "Online"){
        this.getExamSchedule()
      }
    }
  }
  
  get offlineValid(){
    if(this.rescheduleFormControls.mode.value == 'Offline'){
      return this.rescheduleForm.value.state != '' && this.rescheduleForm.value.city != '' &&this.rescheduleForm.value.center != '' ? true : false;
    }
    return this.rescheduleForm.valid;
  }
  dates: any = [];
  times: any = {};

  downloadReport(test){
    let params ={
      phone: test?.studentid,
      attempt: test?.attempt,
      ruleid: test?.ruleid,
    }
    this.testListService.scoreTestReport(params).subscribe((resp: any) => {
      console.log(resp,'testrecrod resp')
      resp.examsubmitDate = new Date(resp?.examSubmittedOn)
      let componentFactory2 = this.resolver.resolveComponentFactory(ScoreReportComponent)
      const {instance} = this.scorecomponentreport.createComponent (componentFactory2, null, this.injector);
      instance.testData = resp;
      instance.selectedTestData = test;           
    })
  }

  getExamSchedule() {
    console.log(this.selectedTestData);
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    const formVal = this.rescheduleForm.value;
    console.log(formVal);
    if(formVal.grade !=''){
      const grade = this.grades.find(g => g.gradeId == formVal.grade).name;
      const user = localStorage.getItem('user_details_from_server') ? JSON.parse( localStorage.getItem('user_details_from_server'))  :{}
    const coursetype = formVal?.exam;
  this.scheduleService.getScorePackages({grade: grade?.replace(/[^0-9]/gi, ''),examName: formVal?.exam,userId:user?.userId,producttype: 'assessment,liveclasses'}).subscribe((resp)=>{
      
      this.rescheduleSubscriptionPackage = resp?.find(v=>v?.productId == 7)
    }) 
    this.subscriptionService.GetScoreScheduleList().subscribe((resp:any) => {
      console.log(resp);
      console.log(coursetype,grade)
      let examSocreByGrade = resp.find(ele=>ele?.coursetype?.toUpperCase() == coursetype && ele?.className == grade);
      console.log(examSocreByGrade);
      this.rescheduleForm.get('scheduleid')?.setValue(examSocreByGrade?.scheduleid ? examSocreByGrade?.scheduleid : '');
      this.rescheduleForm.get('duration')?.setValue(examSocreByGrade?.duration ? examSocreByGrade?.duration : '');
        
    });
    }
    
  }
  getScoreTimeSlots() {
    console.log(this.selectedTestData);
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    const formVal = this.rescheduleForm.value;
    console.log(formVal);
    if(formVal.grade !=''){
      const grade = this.grades.find(g => g.gradeId == formVal.grade).name;
      const user = localStorage.getItem('user_details_from_server') ? JSON.parse( localStorage.getItem('user_details_from_server'))  :{}
    const coursetype = formVal?.exam;
  this.scheduleService.getScorePackages({grade: grade?.replace(/[^0-9]/gi, ''),examName: formVal?.exam,userId:user?.userId,producttype: 'assessment,liveclasses',pageUrl: 'https://devinfinitylearn.in/score'}).subscribe((resp)=>{
      
      this.rescheduleSubscriptionPackage = resp?.find(v=>v?.productId == 7)
    })  
    // let slotbody ={grade: [Number(grade.replace('th',''))], exam_type: [getCourseId(coursetype)], test_type: ['fc180abf-a9cb-4bea-b30e-28d8442ae3b8'],phone:user?.phone}
    // if(!Object.values(slotbody).every(v=>v)){
    //   return;
    // }
    const state = formVal.state;
    const city = formVal.city;
    const campus = formVal.center;
    this.scheduleService.getScoreTimeSlots({examtype: 'SCOREAWAT' ,grade: grade, state,city,campus}).subscribe((d) => {
      console.log(d);
      d = d.filter(ele=>ele?.coursetype?.toUpperCase() == coursetype);
      const flagName = 'is'+formVal.mode.toLowerCase();
      // const slots = d.filter(de => de[flagName]);
      d.forEach(ele=>{
        let serverTime = localStorage.getItem('serverTime');
        let current_time = moment.unix(Number(serverTime)).format("YYYY-MM-DD HH:mm:ss");
        let todayDate = new Date(current_time);
        let examDate = new Date(ele?.span);
        ele.timediffrence = this.timeDiffCalc(examDate,todayDate);
        ele.examDateInHours = this.getExamDateInHours;
        if(examDate < todayDate){
          ele.isPast = true;
        } else {
          ele.isPast = false;
        }
      });
      d = d.filter(ele=>!ele.isPast && ((ele.timediffrence != 0 && (ele.timediffrence == 1 && ele.examDateInHours < 24)) || ele.timediffrence > 1));
      console.log(d);
      const slots = d;
      this.totalSlots = d;
      this.dates = [];
      this.times = {};
      let splitdate = -1;
      // slots.forEach(ele=>{
      //       ++splitdate;
      //       if(ele?.span === '2022-10-16 10:00 AM'){
      //         slots.splice(splitdate,1);
      //       }
      // });
      // let splitdate2 = -1;
      // slots.forEach(ele=>{
      //   console.log(ele,'exams')
      //   let serverTime = localStorage.getItem('serverTime');
      //   let current_time = moment.unix(Number(serverTime)).format("YYYY-MM-DD HH:mm:ss");
      //   let todayDate = new Date(current_time);
      //       let examDate = new Date(ele?.span);
      //       let lessthree = this.timeDiffCalc(examDate,todayDate);
      //       ++splitdate2;
      //       if(examDate < todayDate || lessthree < 1){
      //         slots.splice(splitdate2,1);
      //       }
      //       if(lessthree <=0 && this.getExamDateInHours < 25){
      //         slots.splice(splitdate2,1);
      //       }
      // });
      slots.forEach(se => {
        const execRes = testSpanFormat.exec(se?.span);
        if(execRes) {
          const dt = Number(execRes[3]);
          const dateStr = dt + (dateSuffixes?.[dt]? dateSuffixes?.[dt]: "th" )+ " " + monthNamesArr[Number(execRes?.[2]) - 1] + " "+ execRes?.[1] ;
          this.dateDayarr.push(days[ moment(se?.span,"YYYY-MM-DD HH:mm A").weekday()]);
          if(!this.times[dateStr]){
            this.dates.push(dateStr);
            this.times[dateStr] = [];
          }
          this.datedata = execRes[0];
          let today = new Date(this.datedata);
          today.setMinutes(today.getMinutes() + se.duration);           
          this.times[dateStr].push({
            time: execRes[4],
            ruleid: se?._id,
            span: se?.span,
            slot:se?.slot,
            duration: today,
            scheduleid: se?.scheduleid
          });
          console.log(this.times[dateStr]);
        }
      });
      this.rescheduleForm.get('date')?.setValue('');
        this.rescheduleForm.get('time')?.setValue('');
        this.rescheduleForm.get('ruleid')?.setValue('');
        this.rescheduleForm.get('span')?.setValue('');
        this.rescheduleForm.get('scheduleid')?.setValue('');
        this.rescheduleForm.get('duration')?.setValue('');
        
    });
    }
    
  }
  timeDiffCalc(examData,today) {
    let diffInMilliSeconds = Math.abs(examData - today) / 1000;
    const days = Math.floor(diffInMilliSeconds / 86400);
    diffInMilliSeconds -= days * 86400;
    const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
    diffInMilliSeconds -= hours * 3600;
    this.getExamDateInHours = hours;
    this.rescheduleTime = days;
    return days;
  }

  getExamSlots() {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    const formVal = this.rescheduleForm.value;
    if(formVal.grade !=''){
      const grade = this.grades.find(g => g.gradeId == formVal.grade).name;
      const user = localStorage.getItem('user_details_from_server') ? JSON.parse( localStorage.getItem('user_details_from_server'))  :{}
    const coursetype = [formVal.exam];
  this.scheduleService.getScorePackages({grade: grade?.replace(/[^0-9]/gi, ''),examName: formVal.exam,userId:user?.userId,producttype: 'assessment,liveclasses'}).subscribe((resp)=>{
      
      this.rescheduleSubscriptionPackage = resp?.find(v=>v?.productId == 7)
    })  
    let slotbody ={grade: [Number(grade.replace('th',''))], exam_type: [getCourseId(coursetype)], test_type: ['fc180abf-a9cb-4bea-b30e-28d8442ae3b8'],phone:user?.phone}
    if(!Object.values(slotbody).every(v=>v)){
      return;
    }
    this.scheduleService.getSlots(slotbody).subscribe((d) => {
      const flagName = 'is'+formVal.mode.toLowerCase();
      const slots = d.filter(de => de[flagName]);
      this.totalSlots = d;
      this.dates = [];
      this.times = {};
      slots.forEach(se => {
        const execRes = testSpanFormat.exec(se?.span);
        if(execRes) {
          const dt = Number(execRes[3]);
          const dateStr = dt + (dateSuffixes?.[dt]? dateSuffixes?.[dt]: "th" )+ " " + monthNamesArr[Number(execRes?.[2]) - 1] + " "+ execRes?.[1] ;
          this.dateDayarr.push(days[ moment(se?.span,"YYYY-MM-DD HH:mm A").weekday()]);
          if(!this.times[dateStr]){
            this.dates.push(dateStr);
            this.times[dateStr] = [];
          }        
          this.times[dateStr].push({
            time: execRes[4],
            ruleid: se?._id,
            span: se?.span,
            slot:se?.slot
          });
        }
      });
      this.rescheduleForm.get('date')?.setValue('');
        this.rescheduleForm.get('time')?.setValue('');
        this.rescheduleForm.get('ruleid')?.setValue('');
        this.rescheduleForm.get('span')?.setValue('');
        
        
    });
    }
    
  }
  selectSlotDate($event) {  
    console.log($event.target.value);
    this.rescheduleForm.get('date')?.setValue($event?.target?.value);
    const slotObj = this.times[this.rshdForm?.date?.value][0];
    this.selectedIndex = slotObj?.slot;
    this.rescheduleForm.get('time')?.setValue(slotObj?.time);
    this.rescheduleForm.get('ruleid')?.setValue(slotObj?.ruleid);
    this.rescheduleForm.get('scheduleid')?.setValue(slotObj?.scheduleid);
    this.rescheduleForm.get('span')?.setValue(slotObj?.span);
  }
  selectSlotTime($event) {
    console.log($event.target.value);
    const slotObj = this.times[this.rescheduleForm.value.date].find( e => e.ruleid == $event.target.value);
    console.log('slotObj: ', slotObj);
    this.selectedIndex = this.times[this.rescheduleForm.value.date].find(e => e.ruleid == $event?.target?.value)?.slot;
    this.rescheduleForm.get('time')?.setValue(slotObj?.time);
    this.rescheduleForm.get('ruleid')?.setValue(slotObj?.ruleid);
    this.rescheduleForm.get('scheduleid')?.setValue(slotObj?.scheduleid);
    this.rescheduleForm.get('span')?.setValue(slotObj?.span);
    this.rescheduleForm.get('duration')?.setValue(slotObj?.duration);
  }

  selectState($event){
    this.selectedPincode = '';
    console.log($event?.target?.value);
    this.rescheduleForm.get('state')?.setValue($event?.target?.value);
    this.rescheduleForm.get('district')?.setValue('');
    this.rescheduleForm.get('city')?.setValue('');
    this.rescheduleForm.get('center')?.setValue('');
    this.rescheduleForm.get('mode')?.setValue('');
    let selectedState = $event?.target?.value.toUpperCase();
    let flterState = this.pincodefilteredStates.find(v=>v.name == $event?.target?.value)?.regionId;
    console.log(flterState);
    this.pincodefilteredCities = [];
    this.pincodefilteredDistrict = [];
    this.filteredCenters = [];
    this.userService.getDistricts(flterState).subscribe((resp:any)=>{
      console.log(resp,'discricts')
      this.pincodefilteredDistrict = resp?.districtResponse;
      this.pincodefilteredDistrict.sort((a: any, b: any) =>{
        if(a.districtName < b.districtName) { return -1; }
        if(a.districtName > b.districtName) { return 1; }
        return 0;
      });
      console.log(this.pincodefilteredDistrict,'discricts')
    });
    this.isOffline = false;
    this.isOnline = false;
  //   let flterState = this.filteredStates.find(v=>v == $event?.target?.value.toUpperCase()) || '';
  //   console.log(flterState);
  //   let tempArr = this.pincodeList.filter(v => v.State.toUpperCase() == $event?.target?.value.toUpperCase());
  //   this.pincodefilteredDistrict = [];
  //   this.filteredCenters = [];
  //   tempArr.forEach((val)=>{
  //     if(!this.pincodefilteredDistrict.includes(val.District)){
  //       this.pincodefilteredDistrict.push(val.District);
  //     }
  //   })
  // this.pincodefilteredDistrict = [...this.pincodefilteredDistrict].sort();
}
centerChange($event){
  this.rescheduleForm.get('center')?.setValue($event?.target?.value);
  let tempArr = this.newCentersData.find(v => v.Center == $event?.target?.value);
  console.log(tempArr);
  this.centerAddress = tempArr?.CenterAddress;
  if (this.rescheduleForm.get('mode')?.value === 'Offline'){
    this.getScoreTimeSlots();
  }
}  
selectDistrict($event){
  this.rescheduleForm.get('district')?.setValue($event?.target?.value);
  this.rescheduleForm.get('city')?.setValue('');
  this.rescheduleForm.get('center')?.setValue('');
  this.rescheduleForm.get('mode')?.setValue('');
  let selectedDistrict = this.pincodefilteredDistrict.find(ele=>ele.districtName == $event?.target?.value)?.districtId;
  this.pincodefilteredCities = [];
  this.userService.getCitys(selectedDistrict).subscribe((resp:any)=>{
    console.log(resp,'citys')
    this.pincodefilteredCities = resp?.cityResponse;
    this.pincodefilteredCities.sort((a: any, b: any) =>{
      if(a.cityName < b.cityName) { return -1; }
      if(a.cityName > b.cityName) { return 1; }
      return 0;
    });
    console.log(this.pincodefilteredCities,'citys')
  });
  this.isOffline = false;
  this.isOnline = false;
  // let tempArr = this.pincodeList.filter(v => v.District == $event?.target?.value);
  //   this.pincodefilteredCities = [];
  //   tempArr.forEach((val)=>{
  //     if(!this.pincodefilteredCities.includes(val.City)){
  //       this.pincodefilteredCities.push(val.City);
  //     }
  //   })
  //   this.pincodefilteredCities = [...this.pincodefilteredCities].sort();
  //   console.log(this.pincodefilteredCities);
}

selectCity($event){
  this.rescheduleForm.get('city')?.setValue($event?.target?.value);
  this.rescheduleForm.get('center')?.setValue('');
  this.rescheduleForm.get('mode')?.setValue('');
  let selectedCity = $event?.target?.value.toUpperCase();
  console.log(selectedCity);
  // let tempArr = this.newCentersData.filter(v => v.City == $event?.target?.value);
  //   this.filteredCenters = [];
  //   tempArr.forEach((val)=>{
  //     if(!this.filteredCenters.includes(val.Center)){
  //       this.filteredCenters.push(val.Center);
  //     }
     
  //   });
  //   this.filteredCenters = [...this.filteredCenters].sort();
  let selectedCityId =  this.pincodefilteredCities.find(ele=>ele.cityName == $event?.target?.value)?.cityId;
  this.userService.getCenter(selectedCityId).subscribe((resp:any)=>{
    console.log(resp,'centers')
    this.filteredCenters = resp?.centerResponse;
    this.filteredCenters.sort((a: any, b: any) =>{
      if(a.centerName < b.centerName) { return -1; }
      if(a.centerName > b.centerName) { return 1; }
      return 0;
    });
    console.log(this.pincodefilteredCities,'Centers')
  });
  let tempPin = this.pincodefilteredCities.find(ele=>ele.cityName == $event?.target?.value);
  this.selectedPincode = tempPin?.pinCode;

  if (this.testToReschedule?.source ==='score'){
    // let offlineCity = this.OfflineCitys.find(ele=>ele?.OfflineCity == selectedCity)?.OfflineCity || '';
    // let Offline_Online = this.BothOffline_OnlineCity.find(ele=>ele?.BothOffline_OnlineCity == selectedCity)?.BothOffline_OnlineCity|| '';
    let ModeofExam = this.pincodefilteredCities.find(ele=>ele.cityName == $event?.target?.value);    
    if(ModeofExam?.modeOfExam === "Online"){
      this.isOffline = false;
      this.isOnline = true;
      this.changeFormValue('mode', 'Online');
    } else if (ModeofExam?.modeOfExam === "Offline"){
      this.isOffline = true;
      this.isOnline = true;
    } else if (ModeofExam?.modeOfExam === "Both") {
      console.log('online');
      this.isOnline = true;
      this.isOffline = true;
    } else if (selectedCity === 'other') {
      this.isOnline = true;
      this.isOnline = false;
      this.changeFormValue('mode', 'Online');
    }
  } else if (this.testToReschedule?.source ==='score-toi') {
    let toi_citys = this.toi_citys.find(ele=>ele?.TOI_City_List.toUpperCase() == selectedCity)?.TOI_City_List.toUpperCase() || '';
    let sc_uniqes_citys = this.sc_uniqes_citys.find(ele=>ele?.SC_Unique_City.toUpperCase() == selectedCity)?.SC_Unique_City.toUpperCase() || '';
    let toiOfflineOnlineCitys = this.toiOfflineOnlineCitys.find(ele=>ele?.TCI_Both_Offline_Online.toUpperCase() == selectedCity)?.TCI_Both_Offline_Online.toUpperCase() || '';

    console.log('offline', toi_citys,'online', sc_uniqes_citys)
    
    if(selectedCity === 'Mumbai'){
      this.isOffline = true;
      this.isOnline = true;
    } else if (selectedCity == toi_citys && selectedCity == sc_uniqes_citys){
      this.isOffline = true;
      this.isOnline = true; 
    } else if (selectedCity == toiOfflineOnlineCitys){
      this.isOffline = true;
      this.isOnline = true; 
    } else if (selectedCity != toi_citys || selectedCity != sc_uniqes_citys) {
      console.log('online');
      this.isOnline = true;
      this.isOffline = false;
      this.changeFormValue('mode', 'Online');
    } else if (selectedCity === 'other') {
      this.isOnline = true;
      this.isOnline = false;
      this.changeFormValue('mode', 'Online');
    }
  }
}
rescheduleNow(){
  const testData = this.testToReschedule;
  const formVal = this.rescheduleForm.value;
  console.log(testData,'test data from api');
  console.log(formVal,"data from form");
  console.log(testData?.isoffline);
  if(testData?.isoffline == true && formVal.mode === "Offline"){
    this.changeSubscription();
    this.rescheduleCoupon = 'CHANGE125';
    this.isrescheduleCouponApplied = true;
    console.log("Offline to Offline");
  } else if(testData?.isoffline == false && formVal.mode === "Online"){
    this.changeSubscription();
    this.rescheduleCoupon = 'CHANGE125';
    this.isrescheduleCouponApplied = true;
    console.log("Online to Online");
  } else if (testData?.isoffline == true && formVal.mode === "Online"){
    this.changeSubscription();
    console.log("Offline to Online");
    this.rescheduleCoupon = 'CHANGE125';
    this.isrescheduleCouponApplied = true;
  } else if (testData?.isoffline == false && formVal.mode === "Offline"){
    this.changeSubscription();
    this.isOnlinetoOffline = true;
    console.log("Online to Offline");
    this.rescheduleCoupon = '';
    this.isrescheduleCouponApplied = false;
  }
}
reschedule() {
    this.spinner.show();
    const test = this.testToReschedule;
    const formVal = this.rescheduleForm.value;
    const grade = this.grades.find(g => g.gradeId == formVal.grade).name;
    console.log(test);
    console.log(formVal);
    this.getmysubscriptions(test?.grade?.replace(/[^0-9]/gi, '')).then((resp)=>{
      console.log(resp);
    });
    let body = {      
        scheduleid: formVal?.scheduleid,
        orderid: test?.orderid,
        coupon: test?.coupon,
        reminder: true,
        isoffline: this.rescheduleForm?.value?.mode == 'Offline' ? true : false,
        state: formVal?.state,
        school: test?.school,
        city: formVal?.city,
        center: formVal?.center,
        span: formVal?.span,
        ruleid: formVal?.ruleid,
        studentid: test?.studentid,
        phone: test?.phone,
        admissionNumber: "",
        userid: this.userData?.userId,
        source: test?.source,
        duration: formVal?.duration,
        grade: grade,
        exam: formVal?.exam,
        registrationId: test?._id
      
    }
    this.scheduleService.studentRescheduleExam(body).subscribe((data:any) => {
      console.log(data);
      this.webengage.webEngageEvent({ 
        'event': 'CTA-Reschedule Test Success',
        'exam_name': test?.coursetype,
        'exam_mode': this.rescheduleForm?.value?.mode,
        'grade': test?.grade,
        'date': test?.date,
        'time': test?.time,
        "state": this.rescheduleForm?.value?.state,
        "city": this.rescheduleForm?.value?.city,
        "center": this.rescheduleForm?.value?.center
        })
        
      //{"id":"60a7957b8ffd4ec778b4db4f","message":"Exam registered for student successfully"}
      this.getmysubscriptions(test?.grade?.replace(/[^0-9]/gi, '')).then((resp)=>{
        const user = localStorage.getItem('user_details_from_server') ? JSON.parse( localStorage.getItem('user_details_from_server'))  :{};
        var oldAlreadySchedulepackage:any ={}
        for(var i  =0;i<resp?.length;i++){
        let findsubscription =   resp[i].mySubcriptionDtoList.find(v=>v.userOrderPackageSubscriptionsDto?.scoreId == test?.ruleid || test?.scheduleid);
        if(findsubscription){
          oldAlreadySchedulepackage ={userOrderId: resp[i]?.id,...findsubscription}
          break;
        }
        }
        console.log(oldAlreadySchedulepackage);
          let newUpdatebody= {
            "batchId": "",
            "currentSubscriptionId": oldAlreadySchedulepackage?.packageSubscription?.id,
            "nextSubscriptionId":this.rescheduleSubscriptionPackage?.packageSubscriptionDto?.id,
            "scoreId":this.rescheduleForm?.value?.ruleid || this.rescheduleForm?.value?.scheduleid,
            "userId": user?.userId,
            "userOrderId": oldAlreadySchedulepackage?.userOrderId,
            scoreDetail: {
              "scheduleid": formVal?.scheduleid,
              "ruleid": formVal?.ruleid,
              "orderid": test?.orderid,
              "coupon": test?.coupon,
              "reminder": "false",
              "state":  formVal?.state,
              "city":  formVal?.city,
              "district":  formVal?.district,
              "center":  formVal?.center,
              "span": formVal?.span,        
              "studentid":test?.studentid,
              "phone": test?.studentid,
              "grade": grade,
              "exam": formVal?.exam,
              "duration": formVal?.duration,
              "source": test?.source,
              "school": test?.school,
              "admissionNumber": "",
              "userid":String(this.userData?.userId),
              "isoffline": this.rescheduleForm?.value?.mode == 'Offline' ? true : false,
              "centerAddress": this.centerAddress
          } 
          }
        console.log(newUpdatebody);
        let slotdetails = this.totalSlots.find(newrule=>newrule._id == this.rescheduleForm?.value?.ruleid)
          let spandate =moment(this.rescheduleForm?.value?.span,"YYYY-MM-DD hh:mm A").format("Do MMM YYYY");
           let spantime=moment(this.rescheduleForm?.value?.span,"YYYY-MM-DD hh:mm A").format("h:mm A")+ '-'+moment(this.rescheduleForm?.value?.span,"YYYY-MM-DD hh:mm A").add(slotdetails?.duration,'minutes').format("h:mm A");

          this.scheduleService.changeUserOrderSubscription(newUpdatebody).subscribe(resp=>{
            this.spinner.hide();
            // this.router.navigate(['./subscription/scorepaymentstatus'], {...this.rescheduleForm.value, isreschdeule:true, ...{regres:data}, timeslot:this.selectedIndex,status:'success',scroretestschedule:{date: spandate,time:spantime}, "userOrderId": oldAlreadySchedulepackage?.userOrderPackageSubscriptionsDto?.id})
          },()=>{
            this.spinner.hide();
          })
      });
    });
}

Offlinereschedule() {
  this.spinner.show();
  const test = this.testToReschedule;
  const formVal = this.rescheduleForm.value;
  const grade = this.grades.find(g => g.gradeId == formVal.grade).name;
  console.log(test);
  console.log(formVal);
  this.getmysubscriptions(test?.grade?.replace(/[^0-9]/gi, '')).then((resp)=>{
    const user = localStorage.getItem('user_details_from_server') ? JSON.parse( localStorage.getItem('user_details_from_server'))  :{};
    var oldAlreadySchedulepackage:any ={}
    for(var i  =0;i<resp?.length;i++){
    let findsubscription =   resp[i].mySubcriptionDtoList.find(v=>v.userOrderPackageSubscriptionsDto?.scoreId == test?.ruleid);
    if(findsubscription){
      oldAlreadySchedulepackage ={userOrderId: resp[i]?.id,...findsubscription}
      break;
    }
    }
    console.log(oldAlreadySchedulepackage);
    var param = {
      examName: formVal?.exam,
      grade: grade?.replace(/[^0-9]/gi, ''),
      pageUrl: formVal.mode === "Online" ? 'https://devinfinitylearn.in/score-reschedule-online' : '' || formVal.mode === "Offline" ? 'https://devinfinitylearn.in/score-reschedule' : '',
      isReschedule: true,
      istoi: test?.source === 'score-toi' ? 'toi' : '',
    }
    let slotdetails = this.totalSlots.find(newrule=>newrule._id == this.rescheduleForm?.value?.ruleid)
      let spandate =moment(this.rescheduleForm?.value?.span,"YYYY-MM-DD hh:mm A").format("Do MMM YYYY");
       let spantime=moment(this.rescheduleForm?.value?.span,"YYYY-MM-DD hh:mm A").format("h:mm A")+ '-'+moment(this.rescheduleForm?.value?.span,"YYYY-MM-DD hh:mm A").add(slotdetails?.duration,'minutes').format("h:mm A");
       this.router.navigate(['/score-payment'], 
       {...this.rescheduleForm.value, 
        isreschdeule:true,
        selectedTestData: test, 
        timeslot:this.selectedIndex,status:'success',
         croretestschedule:{date: spandate,time:spantime}, 
        "userOrderId": oldAlreadySchedulepackage,
        packageDetails: param
       });
  });

}

changeSubscription(){
  this.spinner.show();
  const test = this.testToReschedule;
  const formVal = this.rescheduleForm.value;
  const grade = this.grades.find(g => g.gradeId == formVal.grade).name;
  console.log(test);
  console.log(formVal);
  this.getmysubscriptions(test?.grade?.replace(/[^0-9]/gi, '')).then((resp)=>{
    console.log(resp);
  });
  let body = {      
      scheduleid: formVal?.scheduleid,
      orderid: test?.orderid,
      coupon: test?.coupon,
      reminder: true,
      isoffline: this.rescheduleForm?.value?.mode == 'Offline' ? true : false,
      state: formVal?.state,
      school: test?.school,
      city: formVal?.city,
      district:  formVal?.district,
      center: formVal?.center,
      span: formVal?.span,
      ruleid: formVal?.ruleid,
      studentid: test?.studentid,
      phone: test?.phone,
      admissionNumber: "",
      userid: this.userData?.userId,
      source: test?.source,
      duration: formVal?.duration,
      grade: grade,
      exam: formVal?.exam,
      registrationId: test?._id
    
  }
    this.getmysubscriptions(test?.grade?.replace(/[^0-9]/gi, '')).then((resp)=>{
      const user = localStorage.getItem('user_details_from_server') ? JSON.parse( localStorage.getItem('user_details_from_server'))  :{};
      var oldAlreadySchedulepackage:any ={}
      for(var i  =0;i<resp?.length;i++){
      let findsubscription =   resp[i].mySubcriptionDtoList.find(v=>v.userOrderPackageSubscriptionsDto?.scoreId == test?.ruleid || test?.scheduleid);
      if(findsubscription){
        oldAlreadySchedulepackage ={userOrderId: resp[i]?.id,...findsubscription}
        break;
      }
      }
      console.log(oldAlreadySchedulepackage);
        let newUpdatebody= {
          "batchId": "",
          "currentSubscriptionId": oldAlreadySchedulepackage?.packageSubscription?.id,
          "nextSubscriptionId":this.rescheduleSubscriptionPackage?.packageSubscriptionDto?.id,
          "scoreId":this.rescheduleForm?.value?.ruleid || this.rescheduleForm?.value?.scheduleid,
          "userId": user?.userId,
          "userOrderId": oldAlreadySchedulepackage?.userOrderId,
          scoreDetail: {
            "scheduleid": formVal?.scheduleid,
            "ruleid": formVal?.ruleid,
            "orderid": test?.orderid,
            "coupon": test?.coupon,
            "reminder": "false",
            "state":  formVal?.state,
            "city":  formVal?.city,
            "district":  formVal?.district,
            "center":  formVal?.center,
            "span": formVal?.span,        
            "studentid":test?.studentid,
            "phone": test?.studentid,
            "grade": grade,
            "exam": formVal?.exam,
            "duration": formVal?.duration,
            "source": test?.source,
            "school": test?.school,
            "admissionNumber": "",
            "userid":String(this.userData?.userId),
            "isoffline": this.rescheduleForm?.value?.mode == 'Offline' ? true : false,
            "centerAddress": this.centerAddress
        } 
        }
        let pageUrl;
        if(formVal.mode === "Online"){
          pageUrl = 'https://devinfinitylearn.in/score-reschedule-online';
        } else if (formVal.mode === "Offline"){
          pageUrl = 'https://devinfinitylearn.in/score-reschedule';
        }
        var param = {
          examName: formVal?.exam,
          grade: grade?.replace(/[^0-9]/gi, ''),
          pageUrl: pageUrl,
          istoi: test?.source === 'score-toi' ? 'toi' : '',
        }
        let slotdetails = this.totalSlots.find(newrule=>newrule._id == this.rescheduleForm?.value?.ruleid)
        let spandate =moment(this.rescheduleForm?.value?.span,"YYYY-MM-DD hh:mm A").format("Do MMM YYYY");
        let spantime=moment(this.rescheduleForm?.value?.span,"YYYY-MM-DD hh:mm A").format("h:mm A")+ '-'+moment(this.rescheduleForm?.value?.span,"YYYY-MM-DD hh:mm A").add(slotdetails?.duration,'minutes').format("h:mm A");
      console.log(newUpdatebody);

      let userbody = { ...user,
        exams: [this.examsList.find((ind) =>ind.name.replace(/[^a-z]/ig,'').toUpperCase() ==formVal?.exam)],
        grade: this.grades.find((ind) =>ind.name.toLowerCase() == grade)    
      }
      console.log(body);
      this.userService.updateUserDetails(userbody).subscribe(res=>{
        console.log(res);
        setLoggedInUserData(res, this.userService, this.authService);
        this.router.navigate(['/score-payment'], 
        {...this.rescheduleForm.value, 
         isreschdeule:true,
         selectedTestData: test, 
         timeslot:this.selectedIndex,status:'success',
         scoretestschedule:{date: spandate,time:spantime}, 
         oldUserOrderDeatails: oldAlreadySchedulepackage,
         packageDetails: param,
         rescheduleBody: body,
         newUpdatebody: newUpdatebody,
         couponDetails: {couponCode : this.rescheduleCoupon, isCouponApplied: this.isrescheduleCouponApplied}
        });
      })
    });
}

  selectedGrade(){
    this.selectedGradeName = this.grades.find(g => g.gradeId == this.rescheduleForm.value.grade).name
  }

  getExams(){
    this.targetExamService.fetchTargetExamList().subscribe(res=>{
     res.forEach(ele=>{
        console.log(ele.name.replace(/[^a-z]/ig,'').toUpperCase())
      })
      this.examsList = res;
      console.log(this.examsList)
    })
  }
}
